import produce from "immer";
import { IStoreState } from "../../initialStoreState";
import { LoadState } from "../../../constants/enums";
import { AddressHistoryAction } from ".";
import { initialAddressHistoryState } from "./habitationalAddressHistory.types";
import { CLEAR_ADDRESS_HISTORY_STATE, FETCH_ADDRESS_HISTORY_FAILED, FETCH_ADDRESS_HISTORY_LIST_FAILED, FETCH_ADDRESS_HISTORY_LIST_PROGRESS, FETCH_ADDRESS_HISTORY_LIST_SUCCESS, FETCH_ADDRESS_HISTORY_PROGRESS, FETCH_ADDRESS_HISTORY_SUCCESS } from "./habitationalAddressHistoryActions";

export const AddressHistoryReducer = (
  state: IStoreState["habitational"]["addressHistory"] = initialAddressHistoryState,
  action: AddressHistoryAction
) => {
  switch (action.type) {
	case FETCH_ADDRESS_HISTORY_LIST_PROGRESS: {
	  const newState = produce(state, (draftState) => {
		draftState.loading = LoadState.InProgress;
		draftState.list = [];
	  });
	  return newState;
	}
	case FETCH_ADDRESS_HISTORY_LIST_SUCCESS: {
	  const { data } = action.payload;
	  const newState = produce(state, (draftState) => {
		draftState.loading = LoadState.Loaded;
		draftState.list = data;
	  });
	  return newState;
	}

	case FETCH_ADDRESS_HISTORY_LIST_FAILED: {
		const { errorMessage } = action.payload;
		const newState = produce(state, (draftState) => {
		  draftState.loading = LoadState.Failed;
		  draftState.error = errorMessage;
		});
		return newState;
	  }

	case FETCH_ADDRESS_HISTORY_PROGRESS: {
	  const newState = produce(state, (draftState) => {
		draftState.loading = LoadState.InProgress;
	  });
	  return newState;
	}
	case FETCH_ADDRESS_HISTORY_SUCCESS: {
	  const { data } = action.payload;
	  const newState = produce(state, (draftState) => {
		draftState.loading = LoadState.Loaded;
		draftState.addressHistory = data;
	  });
	  return newState;
	}
	case FETCH_ADDRESS_HISTORY_FAILED: {
	  const { errorMessage } = action.payload;
	  const newState = produce(state, (draftState) => {
		draftState.loading = LoadState.Failed;
		draftState.error = errorMessage;
	  });
	  return newState;
	}

	case CLEAR_ADDRESS_HISTORY_STATE: {
	  return initialAddressHistoryState;
	}

	default: {
	  return state;
	}
  }
};
